module.exports = "<p>\r\n    refresh works!\r\n</p>  "